import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export type SubCategoryUpdateDTO = {
  id?: string;
  title?: string;
  media?: any;
  published?: boolean;
  deleted?: boolean;
  category?: { id: string } | null;
};

export const updateSubCategory = async (subCategoryId: string, params: SubCategoryUpdateDTO) => {
  const [response, bodyOrError] = await Api.patch(`sub-categories/${subCategoryId}`, params);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useUpdateSubCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'updateSubCategory',
    (data: { subCategoryId: string; params: SubCategoryUpdateDTO }) => {
      return updateSubCategory(data.subCategoryId, data.params);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getSubCategory']);
        queryClient.invalidateQueries(['suggestedSubCategories']);
        queryClient.invalidateQueries(['getSubCategoriesByPage']);
      },
    },
  );
};
